import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import config from "config"

// ==================== TIPOS DE ASISTENTE ====================

async function fetchTiposAsistente(params = {}) {
  const queryParams = new URLSearchParams()

  if (params.dependenciaId) queryParams.append("dependenciaId", params.dependenciaId)
  if (params.nombre) queryParams.append("nombre", params.nombre)

  let url = `${config.api.baseURL}/tipos-asistente`
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener los tipos de asistente")
      }
      return response.json()
    })
    .then((data) => {
      // El backend ahora retorna estructura paginada: {content: [...], totalElements, totalPages, ...}
      return data.content || []
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      return []
    })
}

async function fetchTipoAsistenteById(id) {
  let url = `${config.api.baseURL}/tipos-asistente/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener el tipo de asistente")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function createTipoAsistente(data) {
  let url = `${config.api.baseURL}/tipos-asistente`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al crear el tipo de asistente")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Tipo de asistente creado exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function updateTipoAsistente(id, data) {
  let url = `${config.api.baseURL}/tipos-asistente/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        return response.json().then((error) => {
          throw new Error(error.error || "Error al actualizar el tipo de asistente")
        })
      }
      return response.json()
    })
    .then((result) => {
      showToast({ title: "Tipo de asistente actualizado exitosamente", icon: "success" })
      return result
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function deleteTipoAsistente(id) {
  return Swal.fire({
    title: "¿Está seguro?",
    text: "Esta acción eliminará el tipo de asistente permanentemente",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      let url = `${config.api.baseURL}/tipos-asistente/${id}`
      const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response?.ok) {
            return response.json().then((error) => {
              throw new Error(error.error || "Error al eliminar el tipo de asistente")
            })
          }
          showToast({ title: "Eliminado", text: "El tipo de asistente ha sido eliminado", icon: "success" })
          return true
        })
        .catch((error) => {
          showToast({ icon: "error", title: "Error", text: error.message })
          throw error
        })
    }
    return false
  })
}

// ==================== DEPENDENCIAS (para dropdown) ====================

async function fetchDependencias(params = {}) {
  const queryParams = new URLSearchParams()

  if (params.sucursalId) queryParams.append("sucursalId", params.sucursalId)

  let url = `${config.api.baseURL}/dependencias-asistencia`
  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`
  }

  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las dependencias")
      }
      return response.json()
    })
    .then((data) => {
      // El backend ahora retorna estructura paginada: {content: [...], totalElements, totalPages, ...}
      return data.content || []
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      return []
    })
}

// ==================== SUCURSALES (para dropdown) ====================

async function fetchSucursales() {
  let url = `${config.api.baseURL}/sucursales`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response?.ok) {
        throw new Error("Error al obtener las sucursales")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      return []
    })
}

export {
  fetchTiposAsistente,
  fetchTipoAsistenteById,
  createTipoAsistente,
  updateTipoAsistente,
  deleteTipoAsistente,
  fetchDependencias,
  fetchSucursales,
}
